import { render, staticRenderFns } from "./afterprice.vue?vue&type=template&id=1f4ef659&scoped=true&"
import script from "./afterprice.vue?vue&type=script&lang=js&"
export * from "./afterprice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4ef659",
  null
  
)

export default component.exports